import * as React from 'react';


export interface ISearchListingHeaderProps {
    resultCount: number,
    searchString: string
}

export class SearchListingHeader extends React.Component<ISearchListingHeaderProps, {}>{    
    render() {
        if (this.props.resultCount > 0) {
            return (
                <h1 className="search-heading">
                    Search Results for &lsquo;{this.props.searchString}&rsquo;
                </h1>
            );
        } else {
            return (
                <h1 className="search-heading">
                    No Search Results for &lsquo;{this.props.searchString}&rsquo;
                </h1>
            );
        }
    };
}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/slp/search-listing-header.tsx